import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import { useLocation } from "react-router-dom";
import ExpenseReportChild from "./ExpenseReportChild";

const ExpenseReport = () => {
  const { state } = useLocation();
  const expenseRecord = state;
  return (
    <MainTemplate>
      <CardBackground>
        <ExpenseReportChild expenseRecord={expenseRecord} />
      </CardBackground>
    </MainTemplate>
  );
};

export default ExpenseReport;
